import { immerable } from "immer";
import type { ScheduleTemplate } from "@/pages/human-resources/time-management/business/schedule-template/ScheduleTemplate.ts";
import type { DailyTag } from "@/pages/human-resources/time-management/business/daily-tag/DailyTag.ts";
import type { Section } from "@/pages/human-resources/time-management/business/Section.ts";
import type { Position } from "@/pages/human-resources/time-management/business/Position.ts";
import type { Role } from "@/pages/human-resources/time-management/business/Role.ts";
import type { HourlyTagCategoryResolver } from "@/pages/human-resources/time-management/business/reference/HourlyTagCategoryResolver.ts";

export class DomainScheduleReferenceData {
  [immerable] = true;

  private readonly rolesMap: Map<string, Role>;
  private readonly positionsMap: Map<string, Position>;
  public constructor(
    public readonly domainId: string,
    public readonly sections: Section[],
    public readonly positions: Position[],
    public readonly roles: Role[],
    public readonly dailyTags: DailyTag[],
    public readonly scheduleTemplates: ScheduleTemplate[],
    public readonly hourlyTagsResolver: HourlyTagCategoryResolver,
  ) {
    this.rolesMap = new Map(this.roles.map((r) => [r.id, r]));
    this.positionsMap = new Map(this.positions.map((p) => [p.id, p]));
  }

  public findPosition(positionId: string | undefined): Position | undefined {
    return positionId === undefined ? undefined : (
        this.positionsMap.get(positionId)
      );
  }

  public findRole(roleId: string | undefined): Role | undefined {
    return roleId === undefined ? undefined : this.rolesMap.get(roleId);
  }
}
